// Kept apart from authorityResume.js so modules that authorityResume.js itself
// imports (earlierIntake.js) can raise it without importing that file back.
export class TreatmentRuntimeResumeError extends Error {
  constructor(code, message, details = {}) {
    super(message);
    this.name = "TreatmentRuntimeResumeError";
    this.code = code;
    this.details = details;
    this.status = details.status ?? null;
    this.causeCode = details.cause_code || null;
    this.retryable = details.retryable ?? false;
    this.action = {
      code: "start_over",
      label: "Start over",
    };
  }
}
